import { render, staticRenderFns } from "./ManualComponent.vue?vue&type=template&id=388922d4&scoped=true&"
import script from "./ManualComponent.vue?vue&type=script&lang=js&"
export * from "./ManualComponent.vue?vue&type=script&lang=js&"
import style0 from "./ManualComponent.vue?vue&type=style&index=0&id=388922d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388922d4",
  null
  
)

export default component.exports